<template>
  <v-card class="advance-details">
    <v-card-title>
      <div class="d-flex justify-space-between align-center flex-sm-row justify-sm-space-between" style="width: 100%;">
        <h3 class="title">Detalles de anticipo</h3>
        <div class="">
          <Button color="danger" @click="showRemoveWarning">
            <div class="d-flex justify-center align-center">
              <v-icon class="mr-1">mdi-trash-can-outline</v-icon>
              <div class="action-label">Eliminar</div>
            </div>
          </Button>
        </div>
      </div>
    </v-card-title>

    <v-card-text v-if="formData" class="py-5">
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="formData.CustomerName"
            label="Nombre del cliente"
            outlined
            dense
            disabled
          />
        </v-col>
        <v-col cols="12" sm="6">
          <DatePicker
            label="Fecha de Pago"
            v-model="formData.DatePayment"
            :value="formData.DatePayment"
            @dateSelected="(newValue) => (formData.DatePayment = newValue)"
            class="mb-5"
            dense
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="formData.Payment"
            label="Monto del Anticipo"
            type="number"
            outlined
            dense
            disabled
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-select
            v-model="formData.TypePayment"
            :items="paymentTypes"
            item-text="Valores"
            item-value="Codigo_Alt"
            label="Tipo de Pago"
            outlined
            dense
            disabled
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="formData.Reference"
            label="Referencia"
            outlined
            dense
            disabled
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
            v-model="formData.Comment"
            label="Comentario"
            outlined
            rows="7"
            dense
          />
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <div class="d-flex justify-space-between mx-2 mb-2" style="width: 100%;">
        <Button color="grey" class="mr-2" @click="restore">
          <div class="d-flex justify-center align-center">
            <v-icon class="mr-1">mdi-restore</v-icon>
            <div class="action-label">Restaurar</div>
          </div>
        </Button>
        <div>
          <Button class="mr-2" @click="$emit('close')">
            <div class="d-flex justify-center align-center">
              <v-icon class="mr-1">mdi-window-close</v-icon>
              <div class="action-label">Cancelar</div>
            </div>
          </Button>
          <Button class="btn-save" @click="save">
            <div class="d-flex justify-center align-center">
              <v-icon class="mr-1">mdi-content-save</v-icon>
              <div class="action-label">Guardar</div>
            </div>
          </Button>
        </div>
      </div>
    </v-card-actions>
    <Block v-if="loading"></Block>
    <alert
      v-model="alert.show"
      :type="alert.type"
      :title="alert.title"
      :message="alert.message"
      @input="alert.onInputEvent"
      @action="alert.onActionEvent"
    >
    </alert>
  </v-card>
</template>

<script>
import Button from "@/components/Button.vue"
import DatePicker from "@/components/DatePicker";
import moment from "moment";
// import { formatDate } from "@/helpers/formatDate";
import { mapGetters } from "vuex";
import Block from "@/components/Block";

export default {
  name: 'AdvancePaymentDetails',
  components: {
    Button,
    DatePicker,
    Block,
  },
  props: {
    advancePaymentData: { 
      type: Object,
      required: true
    },
  },
  data() {
    return {
      loading: false,
      formData: null,
      alert: {
        type: 'success',
        show: false,
        header: '',
        body: '',
        onInputEvent: this.closeAlert,
        onActionEvent: this.closeAlert
      },
    }
  },
  computed: {
    ...mapGetters(['getCatalogMH']),
    paymentTypes() {
      return this.getCatalogMH('FormaPago');
    },
  },
  methods: {
    restore() {
      if (!this.advancePaymentData) {
        console.log('Invalid advance payment data')
        this.$emit('close')
        return
      }
      console.log(this.advancePaymentData)
      this.formData = JSON.parse(JSON.stringify(this.advancePaymentData));
      console.log(this.formData)
      this.formData.DatePayment = moment(this.formData.DatePayment).format('DD/MM/YYYY');
    },
    showAlert(title, message, type = 'success', onInputEvent, onActionEvent) {
      this.alert.type = type;
      this.alert.title = title;
      this.alert.message = message;
      this.alert.show = true;
      this.alert.onInputEvent = onInputEvent 
        ? onInputEvent
        : this.closeAlert
      this.alert.onActionEvent = onActionEvent 
        ? onActionEvent
        : this.closeAlert
      
    },
    closeAlert() {
      this.alert.show = false;
    },
    async save() {
      this.loading = true
      try {
        const updateData = {
          DatePayment: this.formData.DatePayment,
          Comment: this.formData.Comment,
        }

        const response = await this.$API.customerAdvancePayment
          .updateAdvancePayment(this.formData.ID_AdvancePayment, updateData)

        console.log(response)

        this.showAlert(
          'Success', 
          'Avance actualizado exitosamente.', 
          'success',
          this.notifyUpdate
        );
      } catch (err) {
        console.log(err)
        this.showAlert('Error', 'Ha ocurrido actualizando los datos del avance.', 'error');
      }
      this.loading = false
    },
    showRemoveWarning() {
      this.showAlert(
        'Advertencia', 
        '¿Desea eliminar este avance?', 
        'confirm-danger',
        this.closeAlert,
        this.remove
      );
    },
    async remove() {
      this.loading = true
      try {
        const updateData = {
          isDeleted: 1
        }

        await this.$API.customerAdvancePayment
          .updateAdvancePayment(this.formData.ID_AdvancePayment, updateData)

        this.showAlert(
          'Success', 
          'Avance eliminado.', 
          'success',
          this.notifyUpdate
        );
      } catch (err) {
        console.log(err)
        this.showAlert('Error', 'Ha ocurrido eliminando el avance.', 'error');
      }
      this.loading = false
    },
    notifyUpdate() {
      console.log('notify details update')
      this.$emit('update')
      this.$emit('close')
    }
  },
  mounted() {
    this.restore()
  }
}
</script>

<style scoped>
@media (max-width: 320px) {
  .title {
    font-size: 0.9em !important;
  }
}

@media (max-width: 468px) {
  .action-label {
    display: none;
  }
}
</style>